"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getHBListItemTheme = exports.getHBListItemSize = exports.dropdownReferenceTypesMap = void 0;
var _reactDropdownMenu = require("@radix-ui/react-dropdown-menu");
var SIZE_MAP = {
  sm: 'sm',
  md: 'md',
  lg: 'md',
  fit: 'md'
};
var getHBListItemSize = exports.getHBListItemSize = function getHBListItemSize(size) {
  return SIZE_MAP[size] || 'md';
};
var THEME_MAP = {
  "default": 'neutral',
  destructive: 'danger',
  accent: 'accent'
};
var getHBListItemTheme = exports.getHBListItemTheme = function getHBListItemTheme(theme) {
  return THEME_MAP[theme] || 'neutral';
};
var dropdownReferenceTypesMap = exports.dropdownReferenceTypesMap = {
  item: _reactDropdownMenu.Item,
  subTrigger: _reactDropdownMenu.SubTrigger,
  section: _reactDropdownMenu.Label
};
//# sourceMappingURL=HBMenu.constants.js.map